/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_5Inputs */

const en_signup_feature_pro_5 = /** @type {(inputs: Signup_Feature_Pro_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Projects & Sharing`)
};

const fr_signup_feature_pro_5 = /** @type {(inputs: Signup_Feature_Pro_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projets d'équipe et partage`)
};

const de_signup_feature_pro_5 = /** @type {(inputs: Signup_Feature_Pro_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teamprojekte & Austausch`)
};

const it_signup_feature_pro_5 = /** @type {(inputs: Signup_Feature_Pro_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetti di squadra e condivisione`)
};

const ru_signup_feature_pro_5 = /** @type {(inputs: Signup_Feature_Pro_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Командные проекты и обмен опытом`)
};

const es_signup_feature_pro_5 = /** @type {(inputs: Signup_Feature_Pro_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyectos en equipo y compartición`)
};

const zh_cn2_signup_feature_pro_5 = /** @type {(inputs: Signup_Feature_Pro_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队项目与分享`)
};

const ja_signup_feature_pro_5 = /** @type {(inputs: Signup_Feature_Pro_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームプロジェクトと共有`)
};

const hi_signup_feature_pro_5 = /** @type {(inputs: Signup_Feature_Pro_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम प्रोजेक्ट और साझाकरण`)
};

const pt_pt2_signup_feature_pro_5 = /** @type {(inputs: Signup_Feature_Pro_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projetos em equipe e compartilhamento`)
};

/**
* | output |
* | --- |
* | "Team Projects & Sharing" |
*
* @param {Signup_Feature_Pro_5Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_5 = /** @type {((inputs?: Signup_Feature_Pro_5Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_5Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_pro_5(inputs)
	if (locale === "de") return de_signup_feature_pro_5(inputs)
	if (locale === "it") return it_signup_feature_pro_5(inputs)
	if (locale === "ru") return ru_signup_feature_pro_5(inputs)
	if (locale === "es") return es_signup_feature_pro_5(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_pro_5(inputs)
	if (locale === "ja") return ja_signup_feature_pro_5(inputs)
	if (locale === "hi") return hi_signup_feature_pro_5(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_pro_5(inputs)
	return en_signup_feature_pro_5(inputs)
});